var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6935 8.2013C12.6935 7.85389 12.9752 7.57227 13.3226 7.57227H16.6774C17.0248 7.57227 17.3065 7.85389 17.3065 8.2013V8.83033H20.871C21.2184 8.83033 21.5 9.11196 21.5 9.45936C21.5 9.80677 21.2184 10.0884 20.871 10.0884H9.12903C8.78163 10.0884 8.5 9.80677 8.5 9.45936C8.5 9.11196 8.78163 8.83033 9.12903 8.83033H12.6935V8.2013Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1689 12.3485C10.1925 12.1362 10.3721 11.9755 10.5857 11.9755H19.4143C19.6279 11.9755 19.8074 12.1362 19.831 12.3485L19.9989 13.8593C20.3015 16.5826 20.3015 19.331 19.9989 22.0543L19.9824 22.203C19.8722 23.1949 19.1035 23.9857 18.1152 24.1241C16.0485 24.4134 13.9515 24.4134 11.8848 24.1241C10.8965 23.9857 10.1278 23.1949 10.0176 22.203L10.0011 22.0543C9.69849 19.331 9.69849 16.5826 10.0011 13.8593L10.1689 12.3485ZM13.9516 15.2465C13.9516 14.899 13.67 14.6174 13.3226 14.6174C12.9752 14.6174 12.6935 14.899 12.6935 15.2465L12.6935 21.1174C12.6935 21.4648 12.9752 21.7465 13.3226 21.7465C13.67 21.7465 13.9516 21.4648 13.9516 21.1174V15.2465ZM17.3065 15.2465C17.3065 14.899 17.0248 14.6174 16.6774 14.6174C16.33 14.6174 16.0484 14.899 16.0484 15.2465V21.1174C16.0484 21.4648 16.33 21.7465 16.6774 21.7465C17.0248 21.7465 17.3065 21.4648 17.3065 21.1174V15.2465Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizDelete);
export default __webpack_public_path__ + "static/media/quizDelete.50dd82f24a7f83620325bc227ee3694d.svg";
export { ForwardRef as ReactComponent };